var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgErrorPageNotFoundV1 = function SvgErrorPageNotFoundV1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#f0f0f0;}.cls-3{fill:#e0e0e0;}.cls-4{fill:#f5f5f5;}.cls-5{fill:#9fa9ff;}.cls-13,.cls-15,.cls-26,.cls-28,.cls-30,.cls-38,.cls-40,.cls-41,.cls-6{fill:#fff;}.cls-6{opacity:0.7;}.cls-7{fill:#385994;}.cls-8{fill:#5e80e6;}.cls-9{fill:#407bff;}.cls-10{fill:#ffb573;}.cls-11,.cls-16,.cls-17,.cls-18,.cls-23,.cls-40,.cls-41{isolation:isolate;}.cls-11,.cls-29,.cls-37,.cls-38,.cls-40{opacity:0.2;}.cls-12{fill:#49391d;}.cls-13,.cls-17{opacity:0.3;}.cls-14{fill:#c6c9ce;}.cls-15,.cls-41{opacity:0.6;}.cls-16,.cls-22,.cls-26{opacity:0.1;}.cls-18,.cls-30{opacity:0.4;}.cls-19{fill:#ed893e;}.cls-20{fill:#263238;}.cls-21{fill:#a02724;}.cls-24{fill:#c4c8ce;}.cls-25{fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:1.22px;}.cls-27,.cls-32{opacity:0.5;}.cls-31{fill:#f9d3b9;}.cls-33{fill:#b76f64;}.cls-34{fill:#b27d7d;}.cls-35{opacity:0.8;}.cls-36{fill:#545556;}.cls-39{fill:#ff8300;}.cls-42{fill:#adacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.24,
    y: 392.64,
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 535.02,
    y: 408.74,
    width: 33.12,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440.77,
    y: 411.45,
    width: 8.69,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 514.83,
    y: 399.45,
    width: 19.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 170.7,
    y: 401.13,
    width: 43.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 222.8,
    y: 401.13,
    width: 6.33,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.71,
    y: 405.36,
    width: 93.68,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.25,348.05H162.16a5.72,5.72,0,0,1-5.71-5.71V70.91a5.71,5.71,0,0,1,5.71-5.71H355.25A5.71,5.71,0,0,1,361,70.91V342.34A5.72,5.72,0,0,1,355.25,348.05ZM162.16,65.45a5.47,5.47,0,0,0-5.46,5.46V342.34a5.47,5.47,0,0,0,5.46,5.46H355.25a5.47,5.47,0,0,0,5.46-5.46V70.91a5.47,5.47,0,0,0-5.46-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.55,348.05H378.45a5.73,5.73,0,0,1-5.71-5.71V70.91a5.72,5.72,0,0,1,5.71-5.71h193.1a5.71,5.71,0,0,1,5.71,5.71V342.34A5.72,5.72,0,0,1,571.55,348.05ZM378.45,65.45A5.47,5.47,0,0,0,373,70.91V342.34a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V70.91a5.47,5.47,0,0,0-5.46-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M519.79,223.61H541.3a2.7,2.7,0,0,0,2.34-4.05l-10.76-18.63a2.69,2.69,0,0,0-4.67,0l-10.75,18.63A2.7,2.7,0,0,0,519.79,223.61ZM532,206l-.47,9.27h-2l-.49-9.27Zm-3,12.47a1.51,1.51,0,0,1,1.57-1.53,1.54,1.54,0,1,1-1.57,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.19,139.61h21.5a2.7,2.7,0,0,0,2.34-4.05l-10.75-18.62a2.7,2.7,0,0,0-4.68,0l-10.75,18.62A2.7,2.7,0,0,0,205.19,139.61ZM217.39,122l-.48,9.28h-2l-.5-9.28Zm-3,12.47a1.51,1.51,0,0,1,1.56-1.53,1.54,1.54,0,0,1,1.61,1.53,1.56,1.56,0,0,1-1.61,1.55A1.53,1.53,0,0,1,214.36,134.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.89,368.77h21.5a2.7,2.7,0,0,0,2.34-4L276,346.09a2.7,2.7,0,0,0-4.68,0l-10.75,18.63A2.7,2.7,0,0,0,262.89,368.77Zm12.2-17.59-.48,9.27h-2l-.5-9.27Zm-3,12.47a1.51,1.51,0,0,1,1.57-1.53,1.54,1.54,0,1,1-1.57,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.25,341.82h21.51a2.7,2.7,0,0,0,2.33-4.05l-10.75-18.63a2.71,2.71,0,0,0-4.68,0l-10.75,18.63A2.7,2.7,0,0,0,464.25,341.82Zm12.2-17.59-.48,9.28h-2l-.5-9.28Zm-3,12.47a1.51,1.51,0,0,1,1.56-1.53,1.54,1.54,0,1,1,0,3.07A1.52,1.52,0,0,1,473.42,336.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M479.71,106.18h11.91a1.5,1.5,0,0,0,1.3-2.25l-6-10.31a1.49,1.49,0,0,0-2.59,0l-5.95,10.31A1.5,1.5,0,0,0,479.71,106.18Zm6.76-9.75-.26,5.14h-1.09l-.28-5.14Zm-1.68,6.91a.84.84,0,0,1,.87-.85.86.86,0,1,1,0,1.71A.85.85,0,0,1,484.79,103.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.69,263.89h11.9a1.5,1.5,0,0,0,1.3-2.25l-6-10.31a1.48,1.48,0,0,0-2.58,0l-6,10.31A1.5,1.5,0,0,0,182.69,263.89Zm6.75-9.75-.26,5.14h-1.09l-.27-5.14Zm-1.68,6.91a.84.84,0,0,1,.87-.85.85.85,0,1,1,0,1.7A.84.84,0,0,1,187.76,261.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.72,187.67h11.91a1.49,1.49,0,0,0,1.29-2.24L418,175.11a1.5,1.5,0,0,0-2.59,0l-6,10.32A1.5,1.5,0,0,0,410.72,187.67Zm6.75-9.74-.26,5.13h-1.09l-.27-5.13Zm-1.67,6.9a.83.83,0,0,1,.86-.84.84.84,0,0,1,.89.84.86.86,0,0,1-.89.86A.85.85,0,0,1,415.8,184.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 282.36,
    y: 100.71,
    width: 30.94,
    height: 20.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 282.36,
    y: 100.71,
    width: 31,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 214.74,
    y: 176.54,
    width: 30.94,
    height: 20.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 214.74,
    y: 176.54,
    width: 31,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 210.46,
    y: 322.1,
    width: 30.94,
    height: 20.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 210.46,
    y: 322.1,
    width: 31,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 448.68,
    y: 269.4,
    width: 30.94,
    height: 20.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 448.68,
    y: 269.4,
    width: 31,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 516.49,
    y: 295.93,
    width: 30.94,
    height: 20.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 516.49,
    y: 295.93,
    width: 31,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 505.11,
    y: 143.15,
    width: 30.94,
    height: 20.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 505.11,
    y: 143.15,
    width: 31,
    height: 3.36
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-4",
    cx: 387.43,
    cy: 428.48,
    rx: 282.24,
    ry: 17.48
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_bubble",
    "data-name": "Speech bubble"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M559.56,106h28.73a8.85,8.85,0,0,1,8.85,8.85v25a8.85,8.85,0,0,1-8.85,8.85h-5.38l2,7.89-8-7.89h-17.4a8.84,8.84,0,0,1-8.84-8.85v-25A8.84,8.84,0,0,1,559.56,106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M559.56,106h28.73a8.85,8.85,0,0,1,8.85,8.85v25a8.85,8.85,0,0,1-8.85,8.85h-5.38l2,7.89-8-7.89h-17.4a8.84,8.84,0,0,1-8.84-8.85v-25A8.84,8.84,0,0,1,559.56,106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M571.52,114.94a16.19,16.19,0,0,0,.34,1.88l1.93-.47a11.08,11.08,0,0,0-7.07,2.79l1.69-.71-1.34-1.69a1.74,1.74,0,0,0-2.45,0l-1,1a1.74,1.74,0,0,0,0,2.47c.49.48,1.49,1.29,1.46,1.33l1.27-2.06a11.11,11.11,0,0,0-3.07,5.27v-.12h-1.52a1.73,1.73,0,0,0-1.74,1.73v1.4a1.72,1.72,0,0,0,1.76,1.73,6.5,6.5,0,0,1,1.31.05v-.13a10.89,10.89,0,0,0,1.33,3.68l-.85.85a1.73,1.73,0,0,0,0,2.45l1,1a1.74,1.74,0,0,0,2.47,0c.26-.28.51-.53.69-.7a11,11,0,0,0,3.72,1.68v.88a1.74,1.74,0,0,0,1.74,1.74h1.4a1.74,1.74,0,0,0,1.73-1.76v-.77a10.89,10.89,0,0,0,3.88-1.6l.56.57a1.74,1.74,0,0,0,2.46,0l1-1a1.74,1.74,0,0,0,0-2.47l-.6-.59a11.08,11.08,0,0,0,1.47-3.82h1a1.73,1.73,0,0,0,1.73-1.74v-1.4a1.73,1.73,0,0,0-1.75-1.73c-.48,0-.93,0-1.16,0a11.14,11.14,0,0,0-1.6-3.48l1-1a1.76,1.76,0,0,0,0-2.46l-1-1a1.73,1.73,0,0,0-2.47,0c-.48.49-1.13,1.45-1.17,1.42l.75.06a11.23,11.23,0,0,0-5.06-1.87l1,.51,0-2a1.72,1.72,0,0,0-1.73-1.73h-1.4A1.73,1.73,0,0,0,571.52,114.94Zm9.4,12.56a6.81,6.81,0,1,1-6.81-6.81A6.82,6.82,0,0,1,580.92,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M197.09,127.41H154.35a8.84,8.84,0,0,0-8.85,8.84v15a8.84,8.84,0,0,0,8.85,8.84h28.4l13,13.9-7-13.9h8.39a8.84,8.84,0,0,0,8.84-8.84v-15A8.84,8.84,0,0,0,197.09,127.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M197.09,127.41H154.35a8.84,8.84,0,0,0-8.85,8.84v15a8.84,8.84,0,0,0,8.85,8.84h28.4l13,13.9-7-13.9h8.39a8.84,8.84,0,0,0,8.84-8.84v-15A8.84,8.84,0,0,0,197.09,127.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M156.44,142.93a5.07,5.07,0,1,1,5.08,4.87A4.84,4.84,0,0,1,156.44,142.93Zm8.77,0a3.71,3.71,0,1,0-3.69,3.66A3.58,3.58,0,0,0,165.21,142.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.8,144.08a3.76,3.76,0,1,1,3.76,3.7A3.59,3.59,0,0,1,167.8,144.08Zm6.19,0a2.44,2.44,0,1,0-4.87,0,2.44,2.44,0,1,0,4.87,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M184.6,144.08a3.51,3.51,0,0,1-3.65,3.7,3.1,3.1,0,0,1-2.52-1.17v3.73h-1.31v-9.87h1.25v1.15a3.08,3.08,0,0,1,2.58-1.21A3.5,3.5,0,0,1,184.6,144.08Zm-1.32,0a2.43,2.43,0,1,0-2.44,2.55A2.39,2.39,0,0,0,183.28,144.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.5,146.93l.54-1a4.73,4.73,0,0,0,2.54.75c1.21,0,1.72-.37,1.72-1,0-1.63-4.57-.22-4.57-3.1,0-1.29,1.16-2.16,3-2.16a5.22,5.22,0,0,1,2.63.65l-.56,1a3.69,3.69,0,0,0-2.08-.58c-1.15,0-1.7.43-1.7,1,0,1.7,4.57.31,4.57,3.12,0,1.31-1.2,2.14-3.12,2.14A5.17,5.17,0,0,1,185.5,146.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M192.94,146.91a.87.87,0,0,1,.9-.88.85.85,0,0,1,.87.88.86.86,0,0,1-.87.87A.88.88,0,0,1,192.94,146.91Zm.12-8.75h1.54l-.26,6.52h-1Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "126.3 425.72 132.72 429.41 141.81 414.85 135.38 411.15 126.3 425.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "135.38 411.16 141.8 414.86 137.11 422.37 130.69 418.67 135.38 411.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M134.6,424.77h-9a.65.65,0,0,0-.63.51l-1.46,6.59a1.1,1.1,0,0,0,.84,1.3l.25,0c2.91-.05,5-.23,8.68-.23,2.25,0,9,.24,12.15.24s3.52-3.07,2.24-3.36c-5.7-1.24-10-3-11.83-4.6A1.78,1.78,0,0,0,134.6,424.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "229.87 427.44 237.5 426.55 235.3 410.16 227.66 411.04 229.87 427.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "227.66 411.04 235.3 410.16 236.43 418.62 228.79 419.5 227.66 411.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M237.66,424.77h-9a.63.63,0,0,0-.63.51l-1.46,6.59a1.09,1.09,0,0,0,.84,1.3l.24,0c2.91-.05,5-.23,8.69-.23,2.25,0,9,.24,12.15.24s3.51-3.07,2.24-3.36c-5.71-1.24-10-3-11.83-4.6A1.8,1.8,0,0,0,237.66,424.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.4,415.22l-12.82-3.06s-9.29-67.28-31.14-97.77a45.43,45.43,0,0,0-9.19-9.82c-1.36,16.9-3,34.88-4.35,44.45-3.42,23.55-36.55,68.92-36.55,68.92l-11.6-4.87s26.63-49.3,27.91-72.45c1.4-25.13,2-69.21,2.06-74.37H201C204.76,286.66,232.86,333.32,237.4,415.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.4,415.22l-12.82-3.06s-9.29-67.28-31.14-97.77a45.43,45.43,0,0,0-9.19-9.82c-1.36,16.9-3,34.88-4.35,44.45-3.42,23.55-36.55,68.92-36.55,68.92l-11.6-4.87s26.63-49.3,27.91-72.45c1.4-25.13,2-69.21,2.06-74.37H201C204.76,286.66,232.86,333.32,237.4,415.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M224.71,222.88c0,3-.07,6-.11,9s-.15,6-.26,9c-.19,6-.47,12-.78,18.07l-.09-1c.43,2.69.82,5.39,1.21,8.09s.74,5.41,1.1,8.12.67,5.42,1,8.14.58,5.44.79,8.17l-5.17,1c-.82-2.62-1.54-5.26-2.3-7.89s-1.44-5.27-2.13-7.92-1.35-5.29-2-7.94-1.29-5.3-1.89-8l-.07-.33v-.66c-.1-6-.17-12.06-.15-18.09,0-3,0-6,.07-9s.09-6,.2-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M224,219.74c3.22,2-.53,23.09.25,38.93a34.43,34.43,0,0,0,.75,4.71l-10.88,1.22a62.15,62.15,0,0,1-1.53-7.68c-.53-7.38,0-28.25,0-28.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.2,258.67a34.69,34.69,0,0,0,.75,4.72l-10.88,1.22a62.45,62.45,0,0,1-1.53-7.69c-.14-1.9-.21-4.7-.23-7.8,0-4.68,0-10.06.1-14.12,0,0,0,0,0,0,.06-3.71.13-6.32.13-6.32L224,219.74C227.17,221.75,223.42,242.84,224.2,258.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M227.37,289.13l2.07,10.16-9.06.37s-2.45-6.9,2.12-10.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "227.35 306.36 220.53 305.02 220.38 299.66 229.44 299.29 227.35 306.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "213.13 262.79 224.94 260.91 225.28 264.18 213.92 265.36 213.13 262.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "213.13 262.79 224.94 260.91 225.28 264.18 213.92 265.36 213.13 262.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M212.31,249.12c0-4.68,0-10.06.1-14.12,0,0,0,0,0,0a18.52,18.52,0,0,1,3.39-5.16A29.07,29.07,0,0,1,212.31,249.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M193.44,314.39a45.43,45.43,0,0,0-9.19-9.82l1.09-14S192.15,301.75,193.44,314.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M224,219.74c-14.82,24.59-21.4,54.72-21.4,54.72l-7.24,12.43-5-14-1.23-.18-1.8-.27-1.84-.28-3.78-.6-1.91-.32c-.64-.1-1.27-.21-1.91-.33l-1.89-.34-1.87-.35c-1.71-.33-3.38-.67-4.95-1l-.84-.19c-1.16-.27-2.27-.54-3.3-.82s-2-.56-2.81-.84l-.62-.21a155.06,155.06,0,0,1,7.12-29.39c.5-1.43,1-2.8,1.53-4.13A117.5,117.5,0,0,1,177,219l.16-.29c4.6-8.24,13.92-11.83,19.52-10.41a145.85,145.85,0,0,1,15.58,5.52A102.42,102.42,0,0,1,224,219.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224,219.74c-14.82,24.59-21.4,54.72-21.4,54.72l-7.24,12.43-5-14-1.23-.18-1.8-.27-1.84-.28-3.78-.6-1.91-.32c-.64-.1-1.27-.21-1.91-.33l-1.89-.34-1.87-.35c-1.71-.33-3.38-.67-4.95-1l-.84-.19c-1.16-.27-2.27-.54-3.3-.82s-2-.55-2.81-.84l-.62-.21a155.06,155.06,0,0,1,7.12-29.39c.5-1.43,1-2.8,1.53-4.13A117.5,117.5,0,0,1,177,219l.16-.29c4.6-8.24,13.92-11.83,19.52-10.41a145.85,145.85,0,0,1,15.58,5.52A102.42,102.42,0,0,1,224,219.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M200.17,236.92s-.42,2.24-.93,5.4a52.87,52.87,0,0,1-3.05,10.2c-.8,1.63-4.09,8.13-3.46,11s-2.46,9.3-2.46,9.3l-1.23-.18c.76-3.55,3.31-15,4.69-16.37,1.63-1.58,4.17-8.57,3.64-11.2S200.17,236.92,200.17,236.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M189.34,289.13l2.08,10.16-9.06.37s-2.45-6.9,2.12-10.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "189.32 306.36 182.51 305.02 182.36 299.66 191.42 299.29 189.32 306.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M195.06,208.82c1,2.83,9,13,9,13l7.05-7.95a5.5,5.5,0,0,1-1.28-1.62,3.89,3.89,0,0,1,.28-4.13,6.7,6.7,0,0,1,1.28-1.27,1.92,1.92,0,0,0,.22-.18l-3.52-13.13C205.89,198.57,200.24,208,195.06,208.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M209.83,212.21a3.89,3.89,0,0,1,.28-4.13,6.7,6.7,0,0,1,1.28-1.27l-5.23-9.16C202.87,204.94,207.09,210,209.83,212.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.74,182.45s2.84,9.92-2,14.51-7.3-14.26-7.3-14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M222.74,182.45s2.84,9.92-2,14.51-7.3-14.26-7.3-14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M206.15,207a9.27,9.27,0,0,0,11,2.2,10.28,10.28,0,0,0,5.23-5.51c.13-.33.25-.68.36-1,1.84-6.53.87-21.91-5.77-20.67-5.44,1-11-.14-13.32,4.89a10,10,0,0,0-.93,4.58C202.86,198.8,202.59,203.12,206.15,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M218.36,194.45a21.21,21.21,0,0,0,2.65,5.22,3.44,3.44,0,0,1-2.89.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M216,189.22a.36.36,0,0,0-.35.11,2.85,2.85,0,0,1-2.33,1,.35.35,0,1,0-.1.69h0a3.47,3.47,0,0,0,3-1.22.36.36,0,0,0,0-.5h0A.55.55,0,0,0,216,189.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M220.37,188.81a.3.3,0,0,0-.21,0,.35.35,0,0,0-.11.48h0a3.46,3.46,0,0,0,2.74,1.66.34.34,0,0,0,.35-.35h0a.35.35,0,0,0-.34-.35h0a2.79,2.79,0,0,1-2.15-1.35A.37.37,0,0,0,220.37,188.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M204.12,196.56c-.7.21-.75,3.33,0,6.18l-1.25.35a20,20,0,0,1-3-6.51c-1.58-5.94-1.79-9.79-1.23-12.77l9.86-1.27.41,3.23a2.43,2.43,0,0,0-1.19,3c1.06,2.71-.45,6.94-2.53,8.63C205.18,197.45,205.11,196.28,204.12,196.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M204.12,196.56c-.7.21-.75,3.33,0,6.18l-1.25.35a20,20,0,0,1-3-6.51c-1.58-5.94-1.79-9.79-1.23-12.77l9.86-1.27.41,3.23a2.43,2.43,0,0,0-1.19,3c1.06,2.71-.45,6.94-2.53,8.63C205.18,197.45,205.11,196.28,204.12,196.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M199.29,197.34a6.93,6.93,0,0,0,3.85,3.69c2.29.88,3.65-1.12,3.21-3.39-.41-2-2.08-5-4.47-4.85A3.11,3.11,0,0,0,199.29,197.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M200.59,180.87s-1.19-2.07,1.41-4.51,13.5-3.46,16.76-1.43,5.93.52,5.76-.8a2.45,2.45,0,0,1,.18,2.83s2.09-.11,3.11,3a2.63,2.63,0,0,0-2.16.6,3.3,3.3,0,0,1,.86,3,4,4,0,0,0-2.39-1.18,7.1,7.1,0,0,0,1.22,2.13s-4.32.48-6.56-1.16a6.34,6.34,0,0,0,1.72,1.9s-7,1.3-9.34-1.48a4.22,4.22,0,0,0-.7,3.42A4.17,4.17,0,0,1,207.3,186a11.19,11.19,0,0,1-5.94,2.5,8.38,8.38,0,0,0,1-1.37s-3.6,2.1-6,.51a4.57,4.57,0,0,0,.6-1.68l-.94.47S196,181.07,200.59,180.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M213.77,194c-.06.59.27,1.09.67,1.11s.72-.46.75-1.06-.28-1.09-.66-1.1S213.8,193.37,213.77,194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M220.52,194.25c-.07.59.28,1.09.66,1.1s.73-.46.76-1-.28-1.09-.67-1.11S220.55,193.68,220.52,194.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M216.38,206.31c-2,.67-4.62.56-4.79-.66a1.2,1.2,0,0,1,.25-.94,4.53,4.53,0,0,1,3.16-1.77,1.77,1.77,0,0,1,1.47.47C217.18,204.11,217.51,205.94,216.38,206.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M216.38,206.31c-2,.67-4.62.56-4.79-.66a1.2,1.2,0,0,1,.25-.94A6.37,6.37,0,0,1,216.38,206.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.73,206.85s5,15,8.07,20.7l.66-.71s-5.54-15.77-6.39-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.46,214.13a29.55,29.55,0,0,1-4,13.42v1.12s4-3.36,5.18-13.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M201.29,227.21l1-1.75c1.8,2.3,3.33,1.06,3.33,1.06l.66,1.4-1.74,4.81h-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M204.43,230.35s-.68,16.22,0,25.62c.43,6,.89,16.81.59,19.68l-2.71,2.08-2.14-3.28s1.69-4.44.89-15.71,2.11-28,2.11-28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "190.36 207.75 195.75 204.89 203.13 211.73 203.47 220.61 208.74 213.4 211.96 211.76 214.29 215.67 211.34 220.37 209.46 217.94 203.14 223.31 198.48 215.9 195.34 217.59 190.36 207.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "190.36 207.75 195.75 204.89 203.13 211.73 203.47 220.61 208.74 213.4 211.96 211.76 214.29 215.67 211.34 220.37 209.46 217.94 203.14 223.31 198.48 215.9 195.34 217.59 190.36 207.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.14 223.31 208.91 215.91 211.34 220.37 209.46 217.94 203.14 223.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.14 223.31 200.51 213.75 195.34 217.59 198.48 215.9 203.14 223.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M186.92,266.25l-9.2,1s-9.84-14.93-9.08-29.53c.5-1.43,1-2.8,1.53-4.13A117.5,117.5,0,0,1,177,219a16.39,16.39,0,0,1,2.34-1.83l9.51,14.18S189.43,254.49,186.92,266.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M186.69,222.88c0,3-.08,6-.12,9s-.14,6-.25,9q-.3,9-.79,18.07l-.08-1c.43,2.69.81,5.39,1.2,8.09s.74,5.41,1.1,8.12.67,5.42,1,8.14.58,5.44.78,8.17l-5.16,1c-.82-2.62-1.55-5.26-2.31-7.89s-1.43-5.27-2.12-7.92-1.35-5.29-2-7.94-1.28-5.3-1.88-8l-.08-.33v-.66c-.1-6-.16-12.06-.14-18.09,0-3,0-6,.06-9s.09-6,.21-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M182.34,214.89c5.14,2.24,6.7,10.57,6.7,10.57s-2.61,31.89-2.48,33.21.36,3.83.36,3.83l-11,2.1a181,181,0,0,1-1.45-18.06c-.53-12.13,0-22.24,2.5-26.71S182.34,214.89,182.34,214.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.34,214.89c5.14,2.24,6.7,10.57,6.7,10.57s-2.61,31.89-2.48,33.21.36,3.83.36,3.83l-11,2.1a181,181,0,0,1-1.45-18.06c-.53-12.13,0-22.24,2.5-26.71S182.34,214.89,182.34,214.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "174.24 262.76 187.75 260.52 186.92 263.95 175.75 266.25 174.24 262.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "174.24 262.76 187.75 260.52 186.92 263.95 175.75 266.25 174.24 262.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M247.41,312.47l-2.19,31.76a2,2,0,0,1-2.15,1.77L202,343.74a2,2,0,0,1-1.9-2L202.28,310a2,2,0,0,1,2.15-1.77l41.09,2.26A1.93,1.93,0,0,1,247.41,312.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M207.15,310.25,205,342a2,2,0,0,1-2.15,1.78l-.82-.05a2,2,0,0,1-1.9-2L202.28,310a2,2,0,0,1,2.15-1.77l.82,0A2,2,0,0,1,207.15,310.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M226.09,339.87l18.47-3.32s9.35,18,14.84,22.91L238.89,367S229.17,355.38,226.09,339.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.09,339.87l18.47-3.32s9.35,18,14.84,22.91L238.89,367S229.17,355.38,226.09,339.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M225.61,322.54c3.46,2.08,13.75,18.6,13.75,18.6l21.56-11.93s-11-10.33-14.44-11.61S225.61,322.54,225.61,322.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M225.31,322.54c3.52,2.08,14,18.6,14,18.6l21.92-11.93s-11.16-10.33-14.68-11.61S225.31,322.54,225.31,322.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M212.3,317s4,9.38,5,18l28.36-5s-4.2-11.09-6-13S212.3,317,212.3,317Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.3,317s4,9.38,5,18l28.36-5s-4.2-11.09-6-13S212.3,317,212.3,317Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M215.28,309.7s3-9.83,7.63-9.13,11,4.91,12.15,10.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M205.83,308.3a2.62,2.62,0,0,1,2.25,2l2.75,14.39a2.08,2.08,0,0,0,1.88,1.56l37,2a1.14,1.14,0,0,0,1.32-1.37l-2.75-14.44a2.61,2.61,0,0,0-2.35-1.95l-41.07-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M205.83,308.3a2.62,2.62,0,0,1,2.25,2l2.75,14.39a2.08,2.08,0,0,0,1.88,1.56l37,2a1.14,1.14,0,0,0,1.32-1.37l-2.75-14.44a2.61,2.61,0,0,0-2.35-1.95l-41.07-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M236.38,334l-2.87-.17a.75.75,0,0,1-.65-.55l-2.28-8.79,3.91.23,2.28,8.78A.37.37,0,0,1,236.38,334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M235.54,331.15h0l-2.75-.16a1.25,1.25,0,0,1-1.06-.9l-.45-1.74a.75.75,0,0,1,.13-.69.67.67,0,0,1,.6-.24l2.75.16a1.24,1.24,0,0,1,1.06.89l.45,1.75a.74.74,0,0,1-.13.68A.69.69,0,0,1,235.54,331.15Zm0-.46a.28.28,0,0,0,.22-.08.32.32,0,0,0,0-.28l-.46-1.75a.77.77,0,0,0-.64-.55l-2.75-.16a.28.28,0,0,0-.22.08.32.32,0,0,0,0,.28l.45,1.75a.8.8,0,0,0,.65.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M235.54,331.15h0l-2.75-.16a1.25,1.25,0,0,1-1.06-.9l-.45-1.74a.75.75,0,0,1,.13-.69.67.67,0,0,1,.6-.24l2.75.16a1.24,1.24,0,0,1,1.06.89l.45,1.75a.74.74,0,0,1-.13.68A.69.69,0,0,1,235.54,331.15Zm0-.46a.28.28,0,0,0,.22-.08.32.32,0,0,0,0-.28l-.46-1.75a.77.77,0,0,0-.64-.55l-2.75-.16a.28.28,0,0,0-.22.08.32.32,0,0,0,0,.28l.45,1.75a.8.8,0,0,0,.65.55Z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M365,422v3a.68.68,0,0,0,.68.67H450.8a4.44,4.44,0,0,0,4.12-6.09l-27-66.82-43.6.29,1.49,8.67,9.62,56.12a3,3,0,0,1-2.92,3.47H365.65A.68.68,0,0,0,365,422Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M365,422v3a.68.68,0,0,0,.68.67H450.8a4.44,4.44,0,0,0,4.12-6.09l-16.73-41.43-10.26-25.39-43.6.29,1.49,8.67L390,386.15l5.44,31.71a3,3,0,0,1-2.92,3.47H365.65A.68.68,0,0,0,365,422Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M392.52,421.33h55.4a1.94,1.94,0,0,0,1.79-2.69l-23.66-56.9H385.82l9.62,56.12A3,3,0,0,1,392.52,421.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "384.33 353.07 385.82 361.74 390 386.15 438.19 378.17 427.94 352.77 384.33 353.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M299.55,228.5H501.41a5.17,5.17,0,0,1,5.16,5.17V370.33a5.16,5.16,0,0,1-5.16,5.16H299.55a5.16,5.16,0,0,1-5.17-5.16V233.67A5.17,5.17,0,0,1,299.55,228.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.55,228.5H501.41a5.17,5.17,0,0,1,5.16,5.17V370.33a5.16,5.16,0,0,1-5.16,5.16H299.55a5.16,5.16,0,0,1-5.17-5.16V233.67A5.17,5.17,0,0,1,299.55,228.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M497.13,375.49h4.28a5.16,5.16,0,0,0,5.16-5.16V233.67a5.16,5.16,0,0,0-5.16-5.17h-4.28a5.16,5.16,0,0,1,5.16,5.17V370.33A5.16,5.16,0,0,1,497.13,375.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 299.03,
    y: 233.56,
    width: 198.6,
    height: 131.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 299.03,
    y: 233.56,
    width: 198.6,
    height: 10.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M493,239a2.47,2.47,0,1,1-2.47-2.47A2.48,2.48,0,0,1,493,239Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M484.83,239a2.47,2.47,0,1,1-2.47-2.47A2.47,2.47,0,0,1,484.83,239Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M476.68,239a2.47,2.47,0,1,1-2.47-2.47A2.48,2.48,0,0,1,476.68,239Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 299.03,
    y: 243.73,
    width: 198.6,
    height: 34.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "303.58 245.24 299.04 253.4 299.04 245.24 303.58 245.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "328.11 245.24 310.68 276.53 299.04 276.53 299.04 272.69 314.33 245.24 328.11 245.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "335.14 276.66 321.36 276.66 338.87 245.24 352.64 245.24 335.14 276.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "359.67 276.66 345.89 276.66 363.4 245.24 377.18 245.24 359.67 276.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "384.2 276.66 370.42 276.66 387.93 245.24 401.71 245.24 384.2 276.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "408.73 276.66 394.96 276.66 412.46 245.24 426.24 245.24 408.73 276.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "433.27 276.43 419.49 276.43 437 245.01 450.77 245.01 433.27 276.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "457.8 276.43 444.02 276.43 461.53 245.01 475.31 245.01 457.8 276.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "497.63 245.14 497.63 248.97 482.34 276.42 468.55 276.42 485.99 245.14 497.63 245.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "497.63 268.5 497.63 276.53 493.16 276.53 497.63 268.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 299.03,
    y: 330.99,
    width: 198.6,
    height: 34.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "303.58 332.79 299.04 340.88 299.04 332.79 303.58 332.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "328.11 332.79 310.68 363.81 299.04 363.81 299.04 360.01 314.33 332.79 328.11 332.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "335.14 363.94 321.36 363.94 338.87 332.79 352.64 332.79 335.14 363.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "359.67 363.94 345.89 363.94 363.4 332.79 377.18 332.79 359.67 363.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "384.2 363.94 370.42 363.94 387.93 332.79 401.71 332.79 384.2 363.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "408.73 363.94 394.96 363.94 412.46 332.79 426.24 332.79 408.73 363.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "433.27 363.71 419.49 363.71 437 332.56 450.77 332.56 433.27 363.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "457.8 363.71 444.02 363.71 461.53 332.56 475.31 332.56 457.8 363.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "497.63 332.69 497.63 336.49 482.34 363.71 468.55 363.71 485.99 332.69 497.63 332.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "497.63 355.86 497.63 363.81 493.16 363.81 497.63 355.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M353.83,315.73v2.89h-1.56v-7.8h2.84a2.88,2.88,0,0,1,2.08.67,2.59,2.59,0,0,1,0,3.58,3,3,0,0,1-2.06.66Zm2.49-2.44a1.19,1.19,0,0,0-.33-.9,1.48,1.48,0,0,0-1-.31h-1.12v2.4H355C355.86,314.48,356.32,314.08,356.32,313.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M363.66,317.05h-3.12l-.56,1.57h-1.64l2.87-7.71H363l2.86,7.71H364.2Zm-.42-1.18-1.15-3.29-1.15,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M372.66,311.45a3.12,3.12,0,0,1,1.21,1.89h-1.64a1.86,1.86,0,0,0-.73-.84,2.2,2.2,0,0,0-1.19-.32,2.32,2.32,0,0,0-1.19.31,2.09,2.09,0,0,0-.81.88,3,3,0,0,0-.28,1.35,2.62,2.62,0,0,0,.65,1.91,2.37,2.37,0,0,0,1.8.69,2.19,2.19,0,0,0,1.44-.5,2.32,2.32,0,0,0,.78-1.38h-2.64v-1.11H374v1.5a3.65,3.65,0,0,1-.64,1.42,3.42,3.42,0,0,1-1.26,1.05,4,4,0,0,1-1.79.39,4.1,4.1,0,0,1-2-.5,3.52,3.52,0,0,1-1.35-1.41,4.66,4.66,0,0,1,0-4.12,3.52,3.52,0,0,1,1.35-1.41,4,4,0,0,1,2-.5A3.8,3.8,0,0,1,372.66,311.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M376.73,312.06v2h2.76v1.2h-2.76v2.09h3.09v1.25h-4.65v-7.8h4.65v1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M390,318.62h-1.56l-3.49-5.3v5.3h-1.56v-7.8h1.56l3.49,5.35v-5.35H390Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M397,311.22a3.67,3.67,0,0,1,1.4,1.42,4.36,4.36,0,0,1,0,4.13,3.67,3.67,0,0,1-1.4,1.42,3.89,3.89,0,0,1-2,.51,4,4,0,0,1-2-.51,3.67,3.67,0,0,1-1.4-1.42,4.44,4.44,0,0,1,0-4.13,3.67,3.67,0,0,1,1.4-1.42,4,4,0,0,1,2-.51A3.89,3.89,0,0,1,397,311.22Zm-3.19,1.24a2.13,2.13,0,0,0-.81.89,3.29,3.29,0,0,0,0,2.7,2.13,2.13,0,0,0,.81.89,2.29,2.29,0,0,0,1.21.31,2.26,2.26,0,0,0,1.2-.31,2,2,0,0,0,.81-.89,3.19,3.19,0,0,0,0-2.7,2,2,0,0,0-.81-.89,2.26,2.26,0,0,0-1.2-.31A2.29,2.29,0,0,0,393.85,312.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M405.43,310.82v1.24h-2.15v6.56h-1.56v-6.56h-2.14v-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M413.54,310.82v1.24h-3.28v2.09h2.63v1.19h-2.63v3.28H408.7v-7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M420.23,311.22a3.67,3.67,0,0,1,1.4,1.42,4.44,4.44,0,0,1,0,4.13,3.67,3.67,0,0,1-1.4,1.42,4.12,4.12,0,0,1-4,0,3.67,3.67,0,0,1-1.4-1.42,4.44,4.44,0,0,1,0-4.13,3.67,3.67,0,0,1,1.4-1.42,4.12,4.12,0,0,1,4,0ZM417,312.46a2,2,0,0,0-.81.89,3.29,3.29,0,0,0,0,2.7,2,2,0,0,0,.81.89,2.5,2.5,0,0,0,2.41,0,2.06,2.06,0,0,0,.81-.89,3.29,3.29,0,0,0,0-2.7,2.06,2.06,0,0,0-.81-.89,2.5,2.5,0,0,0-2.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M424.82,310.82v4.58a2,2,0,0,0,.4,1.37,1.47,1.47,0,0,0,1.17.46,1.44,1.44,0,0,0,1.15-.46,2,2,0,0,0,.4-1.37v-4.58h1.55v4.58a3.81,3.81,0,0,1-.4,1.83,2.66,2.66,0,0,1-1.12,1.11,3.51,3.51,0,0,1-1.62.36,3,3,0,0,1-2.24-.84,3.33,3.33,0,0,1-.84-2.46v-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M437.47,318.62h-1.56l-3.49-5.3v5.3h-1.56v-7.8h1.56l3.49,5.35v-5.35h1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M445.26,316.76a3.45,3.45,0,0,1-1.41,1.37,4.61,4.61,0,0,1-2.2.49h-2.77v-7.8h2.77a4.73,4.73,0,0,1,2.2.48,3.42,3.42,0,0,1,1.41,1.36,4.62,4.62,0,0,1,0,4.1Zm-1.79-.19a2.45,2.45,0,0,0,.69-1.86,2.49,2.49,0,0,0-.69-1.87,2.71,2.71,0,0,0-2-.66h-1.08v5.05h1.08A2.71,2.71,0,0,0,443.47,316.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M373.21,299.62v2.23H362.47V287.52h10.46v2.23h-7.8v3.73h6.92v2.19h-6.92v3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M385.55,301.85l-2.93-4.2a5,5,0,0,1-.55,0h-3.23v4.18h-2.66V287.52h5.89c3.77,0,6.1,1.93,6.1,5.1a4.58,4.58,0,0,1-3.05,4.52l3.3,4.71ZM382,289.77h-3.11v5.71H382c2.33,0,3.54-1.06,3.54-2.86S384.28,289.77,382,289.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M400.51,301.85l-2.93-4.2a5.06,5.06,0,0,1-.55,0h-3.24v4.18h-2.66V287.52H397c3.76,0,6.09,1.93,6.09,5.1a4.58,4.58,0,0,1-3,4.52l3.29,4.71Zm-3.61-12.08h-3.11v5.71h3.11c2.34,0,3.54-1.06,3.54-2.86S399.24,289.77,396.9,289.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M405.07,294.68c0-4.23,3.27-7.36,7.71-7.36s7.71,3.11,7.71,7.36-3.27,7.37-7.71,7.37S405.07,298.92,405.07,294.68Zm12.74,0a5,5,0,1,0-5,5A4.88,4.88,0,0,0,417.81,294.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M432.69,301.85l-2.93-4.2a5.06,5.06,0,0,1-.55,0H426v4.18h-2.67V287.52h5.9c3.76,0,6.1,1.93,6.1,5.1a4.58,4.58,0,0,1-3.05,4.52l3.29,4.71Zm-3.6-12.08H426v5.71h3.11c2.33,0,3.54-1.06,3.54-2.86S431.42,289.77,429.09,289.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M461.85,315.68h21.63a2.71,2.71,0,0,0,2.35-4.07L475,292.88a2.71,2.71,0,0,0-4.7,0L459.5,311.61A2.71,2.71,0,0,0,461.85,315.68ZM474.12,298l-.48,9.33h-2l-.5-9.33Zm-3.05,12.54a1.52,1.52,0,0,1,1.57-1.54,1.55,1.55,0,1,1-1.57,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M314.46,315.68h21.62a2.72,2.72,0,0,0,2.36-4.07l-10.82-18.73a2.71,2.71,0,0,0-4.7,0l-10.81,18.73A2.71,2.71,0,0,0,314.46,315.68ZM326.73,298l-.48,9.33h-2l-.5-9.33Zm-3.05,12.54a1.52,1.52,0,0,1,1.57-1.54,1.55,1.55,0,1,1,0,3.09A1.53,1.53,0,0,1,323.68,310.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M319.74,233.56c27.45,27.51,98,88.74,177.89,84.21V233.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M299,284.12v81.22H418.6c-4.58-16.4-13.75-38.87-31.53-54.92C355.08,281.54,318,281.63,299,284.12Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character-2",
    "data-name": "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M557.07,221.8l-2.73,3.11,7,9.39a2.69,2.69,0,0,0,.36.39c1.28,1.08,8.18,6.85,9.54,6.85s5-3.51,5.53-4.34l2.12-3.34a36.47,36.47,0,0,0,3.7-9.31c.49-1.73.93-3.47,1.26-5.22a50.65,50.65,0,0,0,.74-5.33l-7-.34c-.19,1.56-.43,3.26-.74,4.89s-.64,3.28-1,4.9a24.62,24.62,0,0,1-2.48,6.76s-2.25,3.59-2.51,3.82l-2.7-1.95L557.07,221.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M582.55,199c-3.19.81-5.42,13.93-5.42,13.93l8.79,6s8.43-13.24,6-16.75S587.21,197.83,582.55,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M582.55,199c-3.19.81-5.42,13.93-5.42,13.93l8.79,6s8.43-13.24,6-16.75S587.21,197.83,582.55,199Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "582.84 201.95 580.39 215.18 585.33 218.53 582.84 201.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "582.84 201.95 580.39 215.18 585.33 218.53 582.84 201.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M557.07,221.23l-5.49-5.57-.72,7.84s4.12,2.79,7,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M545.09,215.85,544.9,221a.58.58,0,0,0,.4.58l5.56,1.93.72-7.84-5.44-.7A.93.93,0,0,0,545.09,215.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "599.81 419.94 592.07 419.94 591.55 402.02 599.29 402.02 599.81 419.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "623.38 419.63 615.66 419.11 614.4 401.06 622.12 401.58 623.38 419.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M614.92,417.55l8.67-.7a.61.61,0,0,1,.66.47l1.54,6.78a1.24,1.24,0,0,1-1.13,1.47c-3,.19-4.49.13-8.3.44-2.35.19-5.75.71-9,1s-3.67-2.92-2.34-3.32c5.94-1.79,6.75-3.66,8.64-5.53A2,2,0,0,1,614.92,417.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M591.8,419.05h8.7a.62.62,0,0,1,.62.52l1,6.88a1.25,1.25,0,0,1-1.24,1.38c-3-.05-4.5-.23-8.32-.23-2.35,0-7.22.24-10.47.24s-3.42-3.21-2.07-3.5c6.07-1.3,8.46-3.1,10.5-4.82A2,2,0,0,1,591.8,419.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "591.55 402.02 591.82 411.26 599.56 411.26 599.3 402.02 591.55 402.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "622.12 401.59 614.4 401.06 615.05 410.37 622.78 410.89 622.12 401.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M607.86,176.45c3.83-.45,7.33-1.17,8.28.89s-1.09,5.22-2.85,5.22h-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M613.69,181.5,613.3,183c1.48-.28,3.78,1.48,3.78,1.48S615.72,181.28,613.69,181.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M612,176.51l1.07,1.08c.5-1.41,3.19-2.51,3.19-2.51S612.84,174.65,612,176.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M606.77,179.3c3.82.54,7.39.73,7.78,2.95s-2.38,4.78-4.08,4.33l-6-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M582.55,199s-3.69,1.29,3.7,46.7h31.43c-.53-12.79-.54-20.68,5.57-46.93A93.17,93.17,0,0,0,609.9,197a101.32,101.32,0,0,0-14.27,0C589.5,197.59,582.55,199,582.55,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M582.55,199s-3.69,1.29,3.7,46.7h31.43c-.53-12.79-.54-20.68,5.57-46.93A93.17,93.17,0,0,0,609.9,197a101.32,101.32,0,0,0-14.27,0C589.5,197.59,582.55,199,582.55,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M608.49,181c-.9,4.6-1.8,13,1.41,16.07,0,0-1.25,4.66-9.78,4.66-9.39,0-4.49-4.66-4.49-4.66,5.12-1.22,5-5,4.1-8.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M609.9,197a98.39,98.39,0,0,0-14.27,0l-.93.09c-1.14,2.16-1.43,5.48,1.3,10.35,0,0,12.52-5,15.78-10.32C611.16,197.11,610.53,197.07,609.9,197Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 602.13,
    y: 211.17,
    width: 9.09,
    height: 0.78,
    transform: "translate(4.24 -11.79) rotate(1.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 602.13,
    y: 211.17,
    width: 9.09,
    height: 0.78,
    transform: "translate(4.24 -11.79) rotate(1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M604.92,184l-5.19,4.42a14.13,14.13,0,0,1,.44,2.53c2-.28,4.65-2.43,4.85-4.48A6.62,6.62,0,0,0,604.92,184Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M591.33,161.31c-2.05-1.28-11.41-.25-3.39,21.58,1.11,3-1.75,2.71-1.72,4.6s2.25,3.51,5.28,3.48c0,0-4.53-1.38-3.38-3.16s3.27-2.59,2.41-4.78S591.33,161.31,591.33,161.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M608.18,169.25c1,7.61,1.6,10.82-1.44,15.42-4.57,6.93-14.15,6.51-17.42-.64-2.94-6.44-4.1-17.81,2.67-22.25A10.48,10.48,0,0,1,608.18,169.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M589.53,162c3.25,5.56,14.66,13.65,23.51,15.95,0,0,4.54-14.64-7.18-19.78C596,153.83,589.53,162,589.53,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M586.25,245.72s-6.11,59.62-5.6,83.22c.53,24.55,9.52,80.53,9.52,80.53h10.47s-1.66-54.55-.73-78.66c1-26.28,9.36-85.09,9.36-85.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M599.81,260.56c-7.72,15.53-1.55,43.86,1.18,54.4,1.4-15.83,3.76-35.18,5.6-49.39C605.42,257.53,603.37,253.4,599.81,260.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M599.81,260.56c-7.72,15.53-1.55,43.86,1.18,54.4,1.4-15.83,3.76-35.18,5.6-49.39C605.42,257.53,603.37,253.4,599.81,260.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M594.55,245.72s5.6,62.81,9,83.15c4,24,10.84,80.11,10.84,80.11H624s3.41-61.19,3.48-79.79c.1-28.53-1.5-66.14-9.83-83.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M597.18,173.59c.12.62-.11,1.18-.51,1.26s-.82-.36-.94-1,.11-1.17.51-1.25S597.06,173,597.18,173.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M590.25,175c.12.62-.1,1.18-.5,1.25s-.83-.35-1-1,.11-1.18.51-1.25S590.13,174.34,590.25,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M589.5,174l-1.56-.14S588.92,174.85,589.5,174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M592.29,175.65a16.41,16.41,0,0,1-1.42,4.33,2.7,2.7,0,0,0,2.27,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M595.73,182a.19.19,0,0,1,0-.37,4.91,4.91,0,0,0,3.58-2.67.19.19,0,0,1,.24-.1.18.18,0,0,1,.1.24,5.23,5.23,0,0,1-3.85,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M611.14,177a5.61,5.61,0,0,1-2.27,3.64c-1.61,1.14-3.07-.15-3.17-2-.09-1.67.63-4.28,2.51-4.68A2.52,2.52,0,0,1,611.14,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M598.29,170.34a.35.35,0,0,1-.25-.1c-1.21-1.15-3.64-1-3.67-1a.37.37,0,0,1,0-.73c.11,0,2.78-.13,4.22,1.24a.37.37,0,0,1,0,.52A.39.39,0,0,1,598.29,170.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M586,170.51a.45.45,0,0,1-.19,0,.36.36,0,0,1-.12-.5,3.63,3.63,0,0,1,2.81-1.82h0a.37.37,0,0,1,.37.36.35.35,0,0,1-.35.37,2.92,2.92,0,0,0-2.21,1.47A.37.37,0,0,1,586,170.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M626.65,207.06a123.61,123.61,0,0,1,4.67,13.66,77.73,77.73,0,0,1,2.78,14.43l.1,1.92a8.92,8.92,0,0,1,0,1.21,7.76,7.76,0,0,1-.21,1.47,15.46,15.46,0,0,1-1.71,4.08A43.39,43.39,0,0,1,628,250a93.91,93.91,0,0,1-10,10.31l-2.85-2.69c2.75-3.68,5.53-7.42,8-11.22a48.14,48.14,0,0,0,3.22-5.65,11.43,11.43,0,0,0,.84-2.44c0-.1,0-.27,0-.27s0-.28-.05-.54l-.17-1.58a89,89,0,0,0-3.1-13c-1.33-4.32-2.87-8.7-4.47-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M623.25,198.79c3.15,1,6.93,11.8,6.93,11.8L618,219.33s-4.46-9.05-3.14-13.12C616.21,202,619.66,197.7,623.25,198.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M623.25,198.79c3.15,1,6.93,11.8,6.93,11.8L618,219.33s-4.46-9.05-3.14-13.12C616.21,202,619.66,197.7,623.25,198.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M611,418.88l-.08-.06a1,1,0,0,1-.38-.94.61.61,0,0,1,.32-.54c.87-.48,3.33.84,3.61,1a.17.17,0,0,1,.09.18.18.18,0,0,1-.12.16C613.46,419,611.78,419.4,611,418.88Zm2.9-.43c-1-.5-2.41-1.05-2.86-.79a.23.23,0,0,0-.13.24.66.66,0,0,0,.24.63C611.53,418.86,612.55,418.82,613.87,418.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M614,418.52c-.81-.52-2-1.86-2-2.65a.64.64,0,0,1,.57-.56.93.93,0,0,1,.8.18c.9.67,1.09,2.89,1.09,3a.16.16,0,0,1-.07.16.19.19,0,0,1-.19,0A2.1,2.1,0,0,1,614,418.52Zm-.86-2.77a.55.55,0,0,0-.45-.08c-.23,0-.27.15-.29.24-.06.54.92,1.72,1.7,2.24a4.22,4.22,0,0,0-.91-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M588.9,420.4a2.9,2.9,0,0,1-1.88-.48,1,1,0,0,1-.33-.89.6.6,0,0,1,.31-.49c1-.51,4,1.06,4.38,1.24a.19.19,0,0,1,.1.19.17.17,0,0,1-.15.15A13.1,13.1,0,0,1,588.9,420.4Zm-1.38-1.6a.8.8,0,0,0-.34.06.22.22,0,0,0-.12.2.63.63,0,0,0,.21.59c.47.42,1.74.49,3.45.21A9.92,9.92,0,0,0,587.52,418.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M591.3,420.13l-.08,0c-.92-.42-2.74-2.09-2.6-3,0-.21.18-.47.69-.52a1.3,1.3,0,0,1,1,.32c1,.81,1.15,2.89,1.16,3a.16.16,0,0,1-.08.16A.21.21,0,0,1,591.3,420.13ZM589.45,417h-.11c-.33,0-.35.17-.36.22-.09.52,1.15,1.84,2.09,2.41a4.22,4.22,0,0,0-1-2.39A1,1,0,0,0,589.45,417Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M616.12,256.7l-8.29,1.09,5.81,5.3s4.71-1.6,5.23-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M603.7,262.78l4,3.31a1.08,1.08,0,0,0,1.3.07l4.59-3.07-5.81-5.3L603.66,262A.51.51,0,0,0,603.7,262.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M596.42,172.63l-1.56-.14S595.85,173.49,596.42,172.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M618.15,243.88l.8,2.81c.11.22-.14.44-.51.44H586.09c-.28,0-.51-.13-.53-.31l-.29-2.82c0-.19.23-.36.54-.36h31.83A.57.57,0,0,1,618.15,243.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M618.15,243.88l.8,2.81c.11.22-.14.44-.51.44H586.09c-.28,0-.51-.13-.53-.31l-.29-2.82c0-.19.23-.36.54-.36h31.83A.57.57,0,0,1,618.15,243.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M613.88,247.44h.85c.17,0,.3-.09.29-.2l-.4-3.65c0-.11-.16-.19-.33-.19h-.86c-.17,0-.3.08-.28.19l.4,3.65C613.56,247.35,613.71,247.44,613.88,247.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M588.49,247.44h.85c.17,0,.3-.09.29-.2l-.4-3.65c0-.11-.16-.19-.33-.19h-.85c-.17,0-.3.08-.29.19l.4,3.65C588.17,247.35,588.32,247.44,588.49,247.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M601.18,247.44H602c.16,0,.29-.09.28-.2l-.4-3.65c0-.11-.16-.19-.33-.19h-.85c-.17,0-.3.08-.29.19l.4,3.65C600.86,247.35,601,247.44,601.18,247.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M539.73,163.87a18.13,18.13,0,1,1-30.82,3.83l9.91,12.59,9.66-1.39,3.63-9.06-9.91-12.6A18.13,18.13,0,0,1,539.73,163.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M609.78,311.58a18.13,18.13,0,1,1,30.82-3.83l-9.91-12.59L621,296.55l-3.63,9.06,9.91,12.6A18.13,18.13,0,0,1,609.78,311.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M539.73,163.87a18.13,18.13,0,1,1-30.82,3.83l9.91,12.59,9.66-1.39,3.63-9.06-9.91-12.6A18.13,18.13,0,0,1,539.73,163.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M609.78,311.58a18.13,18.13,0,1,1,30.82-3.83l-9.91-12.59L621,296.55l-3.63,9.06,9.91,12.6A18.13,18.13,0,0,1,609.78,311.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M618.92,293.87h0a9.56,9.56,0,0,1-13.44-1.61L529,195a9.58,9.58,0,0,1,1.61-13.44h0A9.57,9.57,0,0,1,544,183.19l76.49,97.24A9.57,9.57,0,0,1,618.92,293.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M618.92,293.87h0a9.56,9.56,0,0,1-13.44-1.61L529,195a9.58,9.58,0,0,1,1.61-13.44h0A9.57,9.57,0,0,1,544,183.19l76.49,97.24A9.57,9.57,0,0,1,618.92,293.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M614.44,288.17h0a4.93,4.93,0,0,1-6.91-.82l-73.28-93.17a4.91,4.91,0,0,1,.82-6.9h0a4.91,4.91,0,0,1,6.9.82l73.29,93.17A4.91,4.91,0,0,1,614.44,288.17Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Traffic_Cone",
    "data-name": "Traffic Cone"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "545.38 406.64 531.53 337.71 526.23 337.71 512.39 406.64 502.22 412.87 502.22 414.71 555.22 414.71 555.22 412.87 545.38 406.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 502.22,
    y: 412.87,
    width: 53,
    height: 2.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "531.53 337.71 526.23 337.71 512.22 406.44 545.21 406.44 531.53 337.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "540.77 384.13 537.62 368.31 520 368.31 516.77 384.13 540.77 384.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "312.86 429.11 300.43 367.26 295.68 367.26 283.25 429.11 274.13 434.7 274.13 436.35 321.69 436.35 321.69 434.7 312.86 429.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 274.13,
    y: 434.7,
    width: 47.56,
    height: 2.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "300.43 367.26 295.68 367.26 283.11 428.93 312.71 428.93 300.43 367.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "308.72 408.91 305.9 394.71 290.08 394.71 287.19 408.91 308.72 408.91"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Tool_box",
    "data-name": "Tool box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M486.94,423.58l3.57,1.56a5.44,5.44,0,0,1-5.71,1.19,5,5,0,0,1-2.73-6,4.33,4.33,0,0,1,1.3-2.11l-9.67-24.74c-3.48.15-4.95-3.11-4.87-5.36l3.54,1.57a1.63,1.63,0,0,0,2.16-.84,1.65,1.65,0,0,0-.86-2.17l-3.57-1.56a5.44,5.44,0,0,1,5.71-1.19,5.06,5.06,0,0,1,2.87,5.95,4,4,0,0,1-1.16,2.05l9.68,24.74c2.71.15,4.81,3.17,4.72,5.41l-3.61-1.54a1.68,1.68,0,0,0-2.19.86A1.64,1.64,0,0,0,486.94,423.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M486.94,423.58l3.57,1.56a5.44,5.44,0,0,1-5.71,1.19,5,5,0,0,1-2.73-6,4.33,4.33,0,0,1,1.3-2.11l-9.67-24.74c-3.48.15-4.95-3.11-4.87-5.36l3.54,1.57a1.63,1.63,0,0,0,2.16-.84,1.65,1.65,0,0,0-.86-2.17l-3.57-1.56a5.44,5.44,0,0,1,5.71-1.19,5.06,5.06,0,0,1,2.87,5.95,4,4,0,0,1-1.16,2.05l9.68,24.74c2.71.15,4.81,3.17,4.72,5.41l-3.61-1.54a1.68,1.68,0,0,0-2.19.86A1.64,1.64,0,0,0,486.94,423.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M459.34,401.73l-3.78.93a5.44,5.44,0,0,1,3.8-4.42,5,5,0,0,1,5.82,3.09,4.33,4.33,0,0,1,.26,2.47l22.76,13.7c2.67-2.25,5.82-.56,7.13,1.27l-3.77.91a1.64,1.64,0,0,0-1.19,2,1.66,1.66,0,0,0,2,1.2l3.78-.95a5.44,5.44,0,0,1-3.8,4.43,5.05,5.05,0,0,1-5.9-3,4,4,0,0,1-.34-2.34l-22.76-13.7c-2.24,1.54-5.74.43-7-1.4l3.8-1a1.68,1.68,0,0,0,1.21-2A1.65,1.65,0,0,0,459.34,401.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M459.34,401.73l-3.78.93a5.44,5.44,0,0,1,3.8-4.42,5,5,0,0,1,5.82,3.09,4.33,4.33,0,0,1,.26,2.47l22.76,13.7c2.67-2.25,5.82-.56,7.13,1.27l-3.77.91a1.64,1.64,0,0,0-1.19,2,1.66,1.66,0,0,0,2,1.2l3.78-.95a5.44,5.44,0,0,1-3.8,4.43,5.05,5.05,0,0,1-5.9-3,4,4,0,0,1-.34-2.34l-22.76-13.7c-2.24,1.54-5.74.43-7-1.4l3.8-1a1.68,1.68,0,0,0,1.21-2A1.65,1.65,0,0,0,459.34,401.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "535.84 390.34 535.83 390.35 535.89 390.19 500.73 390.19 492.48 411.97 527.5 411.97 527.48 412.03 530.37 412.03 537.79 392.6 535.84 390.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "535.84 390.34 535.83 390.35 535.89 390.19 500.73 390.19 492.48 411.97 527.5 411.97 527.48 412.03 530.37 412.03 537.79 392.6 535.84 390.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "535.89 390.19 527.65 411.97 492.48 411.97 500.73 390.19 535.89 390.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "474.85 405.44 482.98 415.89 485.91 415.45 477.32 405.44 474.85 405.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "474.85 405.44 482.98 415.89 485.91 415.45 477.32 405.44 474.85 405.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "477.32 395.55 485.46 406 488.38 405.56 479.79 395.55 477.32 395.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "477.32 395.55 485.46 406 488.38 405.56 479.79 395.55 477.32 395.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 466.83,
    y: 411.97,
    width: 60.82,
    height: 17.76,
    transform: "translate(994.47 841.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 466.83,
    y: 411.97,
    width: 60.82,
    height: 17.76,
    transform: "translate(994.47 841.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 473.42,
    y: 403.73,
    width: 55.87,
    height: 2.81,
    transform: "translate(1002.72 810.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 473.42,
    y: 403.73,
    width: 55.87,
    height: 2.81,
    transform: "translate(1002.72 810.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 507.85,
    y: 403.73,
    width: 21.45,
    height: 2.81,
    transform: "translate(1037.15 810.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 476.72,
    y: 395.48,
    width: 55.87,
    height: 2.81,
    transform: "translate(1009.32 793.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 476.72,
    y: 395.48,
    width: 55.87,
    height: 2.81,
    transform: "translate(1009.32 793.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 511.15,
    y: 395.48,
    width: 21.45,
    height: 2.81,
    transform: "translate(1043.75 793.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 503.73,
    y: 411.97,
    width: 23.92,
    height: 17.76,
    transform: "translate(1031.37 841.7) rotate(180)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorPageNotFoundV1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Error_PageNotFound_v1.aabb6095.svg";
export { ForwardRef as ReactComponent };